import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "Public/WebApi.asmx/api/registrationService";
const store = {};
const mutations = {
    GET_CAPTCHA(state, data) {
        state.captcha = data;
        state.captchaImage = 'data:image/jpeg;base64,' + data.captchaImage;
        this.captchaLoaded = true;
        if (state.user) {
            state.user.CaptchaToken = data.captchaToken;
            state.status = "loaded";
        }
    },
    GET_NEW_USER(state, data) {
        state.user = data.data.User;
        state.conditions = data.data.Conditions;
        if (state.captcha) {
            state.user.CaptchaToken = state.captcha.captchaToken;
            state.status = "loaded";
        }
    },
    REGISTER_SIMPLE(state, data) {
        if (data.success) {
            state.status = "registered";
            state.authToken = data.authToken;
        }
    },
    RESET_PASSWORD(state, data) {
        if (data.success) {
            state.resetState = data.state;
        }
    },
};
const state = {
    captcha: {
        captchaImage: ""
    },
    captchImage: '',
    captchaLoaded: false,
    user: {},
    conditions: {},
    status: "loading",
    authToken: "",
    resetState: 0,
};
const getters = {};
const actions = {
    getCaptcha({ commit }) {
        axios
            .get(baseUri + '/GetCaptcha')
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_CAPTCHA', res.data);
                }
                else {
                    alert(res.data.errorMessage, "Registration");
                }
            });
    },
    getNewUser({ commit }) {
        axios
            .get(baseUri + '/GetNewUser?a=1')
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_NEW_USER', res);
                }
                else {
                    alert(res.data.errorMessage, "Registration");
                }
            });
    },
    registerSimple({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.user));
        axios
            .post(baseUri + '/registerSimple', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('REGISTER_SIMPLE', res.data);
                } else {
                    this.dispatch("getCaptcha");
                    var err = res.data.errorMessages.map(m => "<li>" + m + "</li>").join('');
                    alert("Registration failed: <ul>" + err + "</ul>", "Registration");
                }
            });
    },
    resetPassword({ commit }, { userName }) {
        var formData = new FormData();
        formData.append("userName", userName);
        formData.append("captchaCode", state.captcha.captchaCode);
        formData.append("captchaToken", state.captcha.captchaToken);
        axios
            .post(baseUri + '/resetPassword', formData)
            .then(res => {
                commit('RESET_PASSWORD', res.data);
            });
    }




};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}